import React from 'react'
import { NavLink } from 'react-router-dom'
import { TbCategoryPlus } from "react-icons/tb";
import { MdDashboard } from "react-icons/md";
import { FaBlogger } from "react-icons/fa6";
import { MdOutlineSimCard } from "react-icons/md";
const Sidebar = ({newSidebarClass}) => {
  
  return (
    <>
    <div className={`sidebar py-3  ${newSidebarClass}`}>
   
        <ul className="list mt-5 ps-0 ">
            <li className='sidebar-nav-list my-4 fs-6'><NavLink to="/admin/dashboard" className="nav-links ps-3">
            <MdDashboard />
            <span className="ms-3 ">Dashboard</span></NavLink></li>
            <li className='sidebar-nav-list  my-4 fs-6'><NavLink to="/admin/package_type" className="nav-links ps-3"><TbCategoryPlus /><span  className="ms-3 ">Packages Type</span></NavLink></li>
            <li className='sidebar-nav-list  my-4 fs-6'><NavLink to="/admin/packages" className="nav-links ps-3">
            <MdOutlineSimCard />
            <span  className="ms-3 ">Packages</span></NavLink></li>
            <li className='sidebar-nav-list  my-4 fs-6'><NavLink to="/admin/relatedpack" className="nav-links ps-3">
            <MdOutlineSimCard />
            <span  className="ms-3 ">Related-Packages</span></NavLink></li>
            <li className='sidebar-nav-list  my-4 fs-6'><NavLink to="/admin/destinations" className="nav-links ps-3">
            <MdOutlineSimCard />
            <span  className="ms-3 ">Destinations</span></NavLink></li>
            <li className='sidebar-nav-list  my-4 fs-6'><NavLink to="/admin/themes" className="nav-links ps-3">
            <MdOutlineSimCard />
            <span  className="ms-3 ">Themes</span></NavLink></li>
            <li className='sidebar-nav-list  my-4 fs-6'><NavLink to="/admin/blogs" className="nav-links ps-3">
            <FaBlogger />
            <span  className="ms-3 ">Blogs</span></NavLink></li>
            <li className='sidebar-nav-list  my-4 fs-6'><NavLink to="/admin/banner" className="nav-links ps-3">
            <MdOutlineSimCard />
            <span  className="ms-3 ">Banner</span></NavLink></li>
            
        </ul>
    </div>
    </>
  )
}

export default Sidebar